export function setDocuments(state, documents){
    state.documents = documents
}

export function setLoading(state, loading){
    state.loading = loading
}

export function setMessageLoading(state, messageLoading){
    state.messageLoading = messageLoading
}

export function setShowPdf(state, showPdf){
  state.showPdf = showPdf
}

export function setDocument(state, document){
  state.document = document
}

export function setSelectedDocument(state, selected_document){
  state.selected_document = selected_document
}

export function setQr(state, qr){
  state.data.qr = qr
}

export function setCufe(state, cufe){
  state.data.cufe = cufe
}

export function setModalShow(state, show){
  state.modal.show = show
}



// WEBPACK FOOTER //
// ./src/modules/send_documents/mutations.js